import React, { Fragment, useEffect, useState } from 'react';
import moment from 'moment';
import Alert_icon from 'dedicated/components/images/alert-icon.svg';

import Input from 'b2b-ui-components-lib/lib/components/input';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';

import { LocationBodyForMPLS } from 'dedicated/components/plan-and-configuration/location-modal/location-body-mpls';

import { DEDICATED_COMMON_PARAMS, isVPN_OR_DI, isVPN } from 'common/constants/app.constants';

import { VPN } from 'home/view/manage-feasibility/constants';

import './index.scss';
import { IPAttributesSection } from 'dedicated/components/plan-and-configuration/location-modal/ip-attributes-section';
import { ServiceDetailsSection } from 'dedicated/components/plan-and-configuration/location-modal/service-details-section';
import { LocationBodyForDI } from 'dedicated/components/plan-and-configuration/location-modal/location-body-di';

const options = [
  { id: 'UNMANAGED', displayName: 'Unmanaged Services' },
  { id: 'MANAGED', displayName: 'Managed Services' }
];

const SPECS_KEY_LIST = ['routingProtocol', 'ipVersion', 'ipType', 'lanIPSubnet', 'wanIPSubnet', 'noOfLAN', 'noOfWAN'];

const billingTypeOption = [
  { id: 'PO', displayName: 'Purchase Order' },
  { id: 'ACCOUNT', displayName: 'Account Level' },
  { id: 'LSI', displayName: 'Site level' }
];

const ViewLineDetailsModal = ({
  isOpen = false,
  setIsOpen = () => {},
  title = '',
  selectedRowData = {},
  formData = {},
  openUploadDocModal = () => {},
  viewLineDetailsOpeningFromDocModal = false,
  sezTableData = {},
  allRecords
}) => {
  const [rowData, setRowData] = useState({});
  const [siteDetailsActive, setSiteDetailsActive] = useState(false);
  const [billingDetailsActive, setBillingDetailsActive] = useState(true);

  useEffect(() => {
    let selectedRowDataCpy = {
      ...selectedRowData,
      ...getSpecsObject(selectedRowData.planDetail.specs),
      ...getRouterSpecs(selectedRowData.planDetail && selectedRowData.planDetail.routerSpecs)
    };
    setRowData(selectedRowDataCpy);
  }, []);

  const getSpecsObject = (specs, key) => {
    if (Array.isArray(specs)) {
      const result = {};
      specs.forEach((spec) => {
        if (SPECS_KEY_LIST.includes(spec.name)) {
          result[spec.name] = spec.value;
        }
      });
      return result;
    }
  };

  const getRouterSpecs = (routerSpecs) => {
    if (Array.isArray(routerSpecs)) {
      const result = {};
      routerSpecs.forEach((spec) => {
        if (spec) {
          result['cpe'] = spec.make;
          result['cpeSpecification'] = spec.model;
        }
      });
      return result;
    }
  };
  const getServiceTypeValue = (id) => {
    if (!id) {
      return {};
    }
    return options.filter((option) => option.id === id)[0];
  };

  const getEstimatedDate = (dateInMs) => {
    return moment(dateInMs).format('DD MMM, YYYY');
  };

  const handleSiteToggle = () => {
    setSiteDetailsActive((siteDetailsActive) => !siteDetailsActive);
  };

  const handleBillingToggle = () => {
    setBillingDetailsActive((billingDetailsActive) => !billingDetailsActive);
  };

  return (
    <div className={`view_lineDetailsdrawer drawer_modal_controller ${isOpen ? 'active' : ''}`}>
      <div className="drawer h-100p">
        <div className="drawer_header">
          <div className="container">
            <div className="drawer_head">
              <div className="title_info">
                <div className="title_heading">{title}</div>
              </div>
              <span
                className="close_icon"
                onClick={() => {
                  if (viewLineDetailsOpeningFromDocModal) {
                    setIsOpen(false);
                    openUploadDocModal(rowData.lineItemId);
                  } else {
                    setIsOpen(false);
                  }
                }}
              ></span>
            </div>
          </div>
        </div>
        <div className="drawer_body">
          <div className="scroll_content">
            <div className="container">
              <div className="row">
                <div className="flg-lg-12 flg-md-12">
                  <div className={` ${'accordion_group'} ${siteDetailsActive ? 'active' : ''}`}>
                    <div className="accodion_head_title">
                      <h6>SITE & PLAN DETAILS</h6> <span className="animatedarrow" onClick={handleSiteToggle}></span>
                    </div>
                    <div className="accordion_detialed_info container_area">
                      <div className="config_form">
                        <div className="select_info">
                          <div className="text">Location Details</div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Input name="" type="text" value={rowData.companyName || ''} label="Company Name" required disabled />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Input name=" " type="text" value={(rowData.planDetail && rowData.planDetail.speed) || ''} label="Selected Bandwidth" required disabled />
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              name=" "
                              type="text"
                              value={(rowData.eligibleMedia && rowData.eligibleMedia.length > 0 && rowData.eligibleMedia[0] && rowData.eligibleMedia[0].media) || ''}
                              label="Media Type"
                              required
                              disabled
                            />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Input name=" " type="text" value={(rowData.address && rowData.address.addressLine1) || ''} label="Address" required disabled />
                          </div>
                        </div>
                        {isVPN_OR_DI() && Object.keys(rowData).length > 0 ? (
                          isVPN() ? (
                            <LocationBodyForMPLS rowData={{ rawContent: rowData, allRecords }} isSummaryRender></LocationBodyForMPLS>
                          ) : (
                            <LocationBodyForDI rowData={{ rawContent: rowData, allRecords }} isSummaryRender></LocationBodyForDI>
                          )
                        ) : (
                          <Fragment>
                            <ServiceDetailsSection rowData={rowData}></ServiceDetailsSection>
                            <IPAttributesSection rowData={rowData}></IPAttributesSection>
                          </Fragment>
                        )}

                        <div className="select_info">
                          <div className="text">Pricing Details </div>
                          <div className="tooltip_wrap">
                            <span className="material-icons-outlined">info</span>
                            <div className="tooltip">
                              <div className="tooltip_content">Pricing Details</div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              name=" "
                              type="text"
                              value={`₹ ${rowData.planDetail && rowData.planDetail.price && rowData.planDetail.price.amount}`}
                              label="Annual Rental Price  "
                              required
                              disabled
                            />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              name=" "
                              type="text"
                              value={`₹ ${rowData.planDetail && rowData.planDetail.price && rowData.planDetail.price.otc}`}
                              label="Installation Charge"
                              required
                              disabled
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              name=" "
                              type="text"
                              value={`${rowData.planDetail && rowData.planDetail.planPeriod && Math.floor(rowData.planDetail.planPeriod / 12)} years`}
                              label="Contract Period"
                              required
                              disabled
                            />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              name=" "
                              type="text"
                              value={`₹ ${
                                rowData.planDetail &&
                                rowData.planDetail.planPeriod &&
                                Math.floor(rowData.planDetail.planPeriod / 12) * (rowData.planDetail.price.amount + rowData.planDetail.price.otc)
                              }`}
                              label="Total Price"
                              required
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                      {Object.keys(rowData).length > 0 && !rowData.planDetail.standardIp && (
                        <div className="notify_text">* Please note: Pricing for the non-standard IP attributes are under review and will be updated after DOA approval.</div>
                      )}
                    </div>
                  </div>

                  <div className={` ${'accordion_group'} ${billingDetailsActive ? 'active' : ''}`}>
                    <div className="accodion_head_title">
                      <h6>BILLING, INSTALLATION & SHIPPING DETAILS</h6> <span className="animatedarrow" onClick={handleBillingToggle}></span>
                    </div>

                    <div className="accordion_detialed_info  container_area">
                      <div className="config_form">
                        <div className="select_info">
                          <div className="text">{`Billing Type & Address`}</div>
                          <div className="tooltip_wrap">
                            <span className="material-icons-outlined">info</span>
                            <div className="tooltip">
                              <div className="tooltip_content">{`Billing Type & Address`}</div>
                            </div>
                          </div>
                        </div>
                        <div className="radio_box">
                          <RadioGroup
                            options={billingTypeOption}
                            value={formData && formData.billingDetails && formData.billingDetails.type ? formData.billingDetails.type : ''}
                            disabled
                          />
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              name=" "
                              type="text"
                              value={
                                (formData && formData.billingDetails && formData.billingDetails.pinCode && formData.billingDetails.pinCode.value) ||
                                (rowData.billingAddress && rowData.billingAddress.pincode)
                              }
                              label="Pincode"
                              required
                              disabled
                            />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              name=" "
                              type="text"
                              value={
                                (formData &&
                                  formData.billingDetails &&
                                  formData.billingDetails.city &&
                                  formData.billingDetails.city.value &&
                                  formData.billingDetails.city.value.displayName) ||
                                (rowData.billingAddress && rowData.billingAddress.city)
                              }
                              label="City"
                              required
                              disabled
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-12 flg-md-12">
                            <Input
                              name=" "
                              type="text"
                              title={
                                (formData && formData.billingDetails && formData.billingDetails.address && formData.billingDetails.address.value) ||
                                (rowData.billingAddress && rowData.billingAddress.addressLine1)
                              }
                              value={
                                (formData && formData.billingDetails && formData.billingDetails.address && formData.billingDetails.address.value) ||
                                (rowData.billingAddress && rowData.billingAddress.addressLine1)
                              }
                              label="Billing Address"
                              required
                              disabled
                            />
                          </div>
                        </div>

                        <div className="select_info">
                          <div className="text">{`Installation Details`}</div>
                          <div className="tooltip_wrap">
                            <span className="material-icons-outlined">info</span>
                            <div className="tooltip">
                              <div className="tooltip_content">{`Installation Details`}</div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Input name=" " type="text" value={getEstimatedDate(rowData.estimatedDate)} label="Estimated Date of Delivery" required disabled />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              name=" "
                              type="text"
                              value={rowData.fiscalCode && rowData.fiscalCode.type === 'GST' && rowData.fiscalCode.id ? rowData.fiscalCode.id : ''}
                              label="GSTN"
                              required
                              disabled
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              name=" "
                              type="text"
                              title={rowData && rowData.address && rowData.address.addressLine1}
                              value={rowData && rowData.address && rowData.address.addressLine1}
                              label="Installation Address"
                              required
                              disabled
                            />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Input name=" " type="text" value={rowData && rowData.address && rowData.address.pincode} label="Pincode" required disabled />
                          </div>
                        </div>

                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Input name=" " type="text" value={rowData && rowData.siteIncharge && rowData.siteIncharge.firstName} label="Site Contact Name" required disabled />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Input name=" " type="text" value={rowData && rowData.siteIncharge && rowData.siteIncharge.phoneNumber} label="Site Contact Number" required disabled />
                          </div>
                        </div>

                        {rowData && rowData.fiscalCode && rowData.fiscalCode.sez && (
                          <div className="subvalue sez-headline">
                            <img src={Alert_icon} alt="Alert" />
                            This is a SEZ Site.
                            <a
                              href="javascript:void(0);"
                              role="button"
                              tabIndex="0"
                              onClick={() => {
                                setIsOpen(false);
                                openUploadDocModal(rowData.lineItemId);
                              }}
                              style={{ paddingLeft: 4 }}
                            >
                              Upload Required Documents
                            </a>
                          </div>
                        )}

                        <div className="select_info">
                          <div className="text">{`Shipping Details`}</div>
                          <div className="tooltip_wrap">
                            <span className="material-icons-outlined">info</span>
                            <div className="tooltip">
                              <div className="tooltip_content">{`Shipping Details`}</div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              name=" "
                              type="text"
                              value={rowData && rowData.shippingAddress && rowData.shippingAddress.addressLine1}
                              title={rowData && rowData.shippingAddress && rowData.shippingAddress.addressLine1}
                              label="Shipping Address"
                              required
                              disabled
                            />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Input name=" " type="text" value={rowData && rowData.shippingAddress && rowData.shippingAddress.pincode} label="Pincode" required disabled />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewLineDetailsModal;
